const FAMILY_BA_URL = document.querySelector("html").getAttribute("family_ba_url");

export default FAMILY_BA_URL



// WEBPACK FOOTER //
// ./src/util/getapi/family_ba.js